// =============================================================================
// Player-facing copy for the opt-in errors the backend returns (security V3-04 / V3-05):
// SMS code limits and the post-draw contact freeze. One place, so the view stays simple and
// the texts are testable. Unknown errors fall back to a generic message.
// =============================================================================

/** Errors after which the current code is gone and the player has to request a new one. */
const NEW_CODE_ERRORS = ['too_many_attempts', 'code_expired', 'no_code']

export function needsNewCode(res) {
  return NEW_CODE_ERRORS.includes(res?.error)
}

/** Minutes to wait, rounded up; null when the server gave no Retry-After. */
function waitMinutes(retryAfter) {
  const seconds = Number(retryAfter)
  return Number.isFinite(seconds) && seconds > 0 ? Math.ceil(seconds / 60) : null
}

/**
 * @param {{ error?: string, attemptsLeft?: number, retryAfter?: number } | null | undefined} res
 * @param {'msisdn' | 'email'} [field] which contact detail a `contact_locked` is about
 * @returns {string | null} null when there is no error
 */
export function optinErrorMessage(res, field = 'msisdn') {
  switch (res?.error) {
    case undefined:
    case null:
      return null
    case 'too_many_requests': {
      const minutes = waitMinutes(res.retryAfter)
      return minutes
        ? `Je hebt te vaak een code aangevraagd. Probeer het over ${minutes} ${minutes === 1 ? 'minuut' : 'minuten'} opnieuw.`
        : 'Je hebt te vaak een code aangevraagd. Probeer het later opnieuw.'
    }
    case 'invalid_msisdn':
      return 'Vul een geldig mobiel nummer in (06…).'
    case 'invalid_code': {
      const left = Number(res.attemptsLeft)
      return Number.isFinite(left) && left > 0
        ? `Code klopt niet. Je hebt nog ${left} ${left === 1 ? 'poging' : 'pogingen'}.`
        : 'Code klopt niet. Probeer opnieuw.'
    }
    case 'too_many_attempts':
      return 'Te vaak een verkeerde code ingevuld. Vraag een nieuwe code aan.'
    case 'code_expired':
      return 'Deze code is verlopen. Vraag een nieuwe code aan.'
    case 'no_code':
      return 'Er is geen geldige code meer. Vraag een nieuwe code aan.'
    case 'contact_locked':
      return field === 'email'
        ? 'Na de prijstrekking kun je je e-mailadres niet meer zelf wijzigen. Klopt het niet? Neem contact op met de klantenservice.'
        : 'Na de prijstrekking kun je je mobiele nummer niet meer zelf wijzigen. Klopt het niet? Neem contact op met de klantenservice.'
    case 'invalid_email':
      return 'Vul een geldig e-mailadres in.'
    default:
      return 'Er ging iets mis. Probeer het opnieuw.'
  }
}
